;
/*! subitotexto.emoji.js
 * Depends on https://github.com/Ranks/emojione
 */

SubitoTexto.emoji = {
	prepForDb    : function ( _text ) {
		if ( typeof emojione == 'undefined' ) {
			console.error( 'EmojiOne JS lib is missing' );
			return false;
		}

		emojione.ascii = true;
		return emojione.toShort( _text );

	},
	convertFromDb: function ( _text ) {

		if ( typeof emojione == 'undefined' ) {
			console.error( 'EmojiOne JS lib is missing' );
			return false;
		}

		emojione.ascii = true;
		emojione.imageType = 'png';


		return emojione.toImage( _text );

	}
};
